import React from 'react';
import BaseReportPage from '../../../components/reports/BaseReportPage';

const ProfitsLossReport = () => {
  const columns = [
    {
      key: 'period',
      label: 'Period',
      type: 'text'
    },
    {
      key: 'totalRevenue',
      label: 'Total Revenue',
      type: 'currency'
    },
    {
      key: 'totalCosts',
      label: 'Total Costs',
      type: 'currency'
    },
    {
      key: 'grossProfit',
      label: 'Gross Profit',
      type: 'currency'
    },
    {
      key: 'operatingExpenses',
      label: 'Operating Expenses',
      type: 'currency'
    },
    {
      key: 'netProfit',
      label: 'Net Profit',
      type: 'currency'
    },
    {
      key: 'profitMargin',
      label: 'Profit Margin %',
      type: 'percentage'
    },
    {
      key: 'branch',
      label: 'Branch',
      type: 'text'
    },
    {
      key: 'status',
      label: 'Status',
      type: 'status'
    }
  ];

  return (
    <BaseReportPage
      title="Profits & Loss Report"
      description="Financial performance analysis with profit and loss statements"
      reportType="profitsLoss"
      columns={columns}
    />
  );
};

export default ProfitsLossReport;